import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    VIEW, ADD, EDIT, DELETE, OPEN, ARCHIVED,
} from "const"
import { okrKeyResultsRoute } from "client/parts/routes"
import { hasAccess } from "client/utils"
import {
    PRM_OKR_OBJECTIVE_KEY_RESULT,
    StoreType,
    IsOwnerOkrKeyResult,
    IsOwnerOkrObjective,

    setOkrKeyResultPopupMenuShow,
    setOkrKeyResultShowConfirmDelete,
    addModal,
} from "client/store"
import {
    PopupMenu,
    PopupMenuItem,
} from "client/components"

import KeyResultUpdateEdit from "client/pages/okr/keyResult/view/updates/edit"

const Menu = () => {
    const session = useSelector((state: StoreType) => state.okrSession.sessionView)

    const objectiveBaseRoute = useSelector((state: StoreType) => state.okrObjective.baseRoute)
    const objectiveRoute = useSelector((state: StoreType) => state.okrObjective.objectiveRoute)
    const objectiveList = useSelector((state: StoreType) => state.okrObjective.objectiveList)

    const activeKeyResult = useSelector((state: StoreType) => state.okrKeyResult.active)
    const menuShow = useSelector((state: StoreType) => state.okrKeyResult.menuShow)
    const menuTarget = useSelector((state: StoreType) => state.okrKeyResult.menuTarget)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const hideMenu = () => {
        dispatch(setOkrKeyResultPopupMenuShow(false))
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    const viewAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, VIEW)
    const addAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, ADD)
    const editAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, EDIT)
    const deleteAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, DELETE)

    if (!activeKeyResult) return null

    const objective = objectiveList[activeKeyResult.objectiveId]

    const isOwnerKeyResult = IsOwnerOkrKeyResult(activeKeyResult, userData.userId)
    const isOwnerObjective = IsOwnerOkrObjective(objective, userData.userId)
    const isOwnerSession = session.owner === userData.userId
    const isOwner = isOwnerKeyResult || isOwnerObjective || isOwnerSession

    const isOpenSession = session.status === OPEN
    const isArchivedSession = session.status === ARCHIVED

    const baseRoute = `${objectiveBaseRoute}${objectiveRoute}`
    const baseKeyResultRoute = `${baseRoute}/${VIEW}/${objective.id}${okrKeyResultsRoute}`
    const viewUrl = `${baseKeyResultRoute}/${VIEW}/${activeKeyResult.id}`
    const editUrl = `${baseKeyResultRoute}/${EDIT}/${activeKeyResult.id}`
    const addChildObjectiveUrl = `${baseRoute}/${EDIT}/0?parentKeyResultId=${activeKeyResult.id}`

    return (
        <PopupMenu
            show={menuShow}
            target={menuTarget}
            placement="right"
        >
            {
                (viewAccess || isOwner)
                && (
                    <PopupMenuItem onClick={() => dispatch(addModal({ url: viewUrl }))}>
                        {lang.details}
                    </PopupMenuItem>
                )
            }
            {
                (editAccess || isOwner)
                && isOpenSession
                && (
                    <PopupMenuItem onClick={() => dispatch(addModal({ url: editUrl }))}>
                        {lang.edit}
                    </PopupMenuItem>
                )
            }
            {
                !isArchivedSession
                && (
                    <PopupMenuItem onClick={() => dispatch(addModal({
                        key: "addUpdate",
                        content: <KeyResultUpdateEdit updateId={0} keyResult={activeKeyResult} />,
                    }))}
                    >
                        {lang.update}
                    </PopupMenuItem>
                )
            }
            {
                (addAccess || isOwner)
                && isOpenSession
                && (
                    <PopupMenuItem onClick={() => dispatch(addModal({ url: addChildObjectiveUrl }))}>
                        {lang.addChildObjective}
                    </PopupMenuItem>
                )
            }
            <PopupMenuItem>
                {lang.clone}
                TODO
            </PopupMenuItem>
            {
                // TODO: when select target to move into, check also (editAccess || isOwnerObjective || isOwnerSession) for the target
                (editAccess || isOwner)
                && isOpenSession
                && (
                    <PopupMenuItem>
                        {lang.move}
                        TODO
                    </PopupMenuItem>
                )
            }
            {
                (deleteAccess || isOwner)
                && isOpenSession
                && (
                    <PopupMenuItem onClick={() => dispatch(setOkrKeyResultShowConfirmDelete(true))}>
                        {lang.delete}
                    </PopupMenuItem>
                )
            }
        </PopupMenu>
    )
}

export default Menu
